export default {
    sound: 50,
    music: 50,
}